import { useState, useEffect } from 'react';

interface UseNavigationProps {
  mobileMenuLevels: string[];
  setMobileMenuLevels: React.Dispatch<React.SetStateAction<string[]>>;
}

export const useNavigation = (props: UseNavigationProps) => {
  const { mobileMenuLevels, setMobileMenuLevels } = props;
  const [currentLevelName, setCurrentLevelName] = useState<string | null>(null);

  useEffect(() => {
    if (!mobileMenuLevels || mobileMenuLevels.length === 0) {
      setCurrentLevelName(null);
    }
  }, [mobileMenuLevels]);

  const showNestedCategory = (e: React.MouseEvent, name: string) => {
    e.preventDefault();
    if (!name) return;
    setMobileMenuLevels((prev) => [...prev, name]);
    setCurrentLevelName(name);
  };

  const closeMenuOnClick = () => setCurrentLevelName(null);

  const goBack = () => setCurrentLevelName(mobileMenuLevels[mobileMenuLevels.length - 1]);

  return {
    currentLevelName,
    setCurrentLevelName,
    showNestedCategory,
    goBack,
    closeMenuOnClick,
  };
};
